import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { observableString } from '@wipo/w-angular/shared';

@Component({
  selector: 'w-sidebar-section',
  templateUrl: './w-sidebar-section.component.html',
  host: {
    '[style.display]': "hiddenTab ? 'none': 'block'",
    'class': 'b-sidebar-section',
  },
  standalone: false
})
/*
@id w-sidebar-section
@name w-sidebar-section
@status release
@description
*/
export class WSidebarSectionComponent {
  @Input() title?: string | Observable<string>; // filter section title
  get titleAsync() {
    return observableString(this.title ?? '');
  }
  @Input() label?: string | Observable<string>; // used to indicate "no-content" section (will show title: label)
  get labelAsync() {
    return observableString(this.label ?? '');
  }

  @Input() isCollapsed: boolean = true; // collapsed state

  @Output() isCollapsedChange = new EventEmitter<boolean>(); // emits on toggle open/close

  @Input() hasFilter: boolean = false; // show filter field
  @Input() filterPlaceholder?: string | Observable<string>; // filter field placeholder, default 'Search'
  get filterPlaceholderAsync() {
    return observableString(this.filterPlaceholder ?? 'Search');
  }
  @Output() wChange = new EventEmitter<string>(); // emits filter field value
  filterText?: string; // filter text
  /* next 2 fields set when mobile tabbed mode */
  hiddenTab = false; // hide content, set from parent
  showInTab: boolean = false; // not collapsable (no not show title with hinge), in tab always visible (uncollapsed)

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.isCollapsedChange.emit(this.isCollapsed);
  }
}
